module.exports = "/_next/static/images/404-crash-0e1acfe33abe2340a9f54b7b02948f87.gif";